import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

interface Section {
  title: string;
  description: string;
}

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.css'],
    standalone: false
})
export class MaintenanceComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Zeeker Solutions | Mantenimiento');
  }

    sections: Section[] = [
    {
      title: 'Pre-Work',
      description: 'Gestionar las expectativas y responsabilidades, Definir el proceso de desarrollo, de acuerdo con las necesidades y prioridades del cliente.'
    },
    {
      title: 'Implementación',
      description: 'Seleccion y despliegue de Herramientas y lanzamiento de pruebas automatizadas, sobre las mismas. Algunas herramientas usadas, como Jira, tfs, Selenium, Capedit ,Zephyr o katalon, etc nos permiten realizar estas tareas con gran eficiencia.'
    },
    {
      title: 'Lanzamiento',
      description: 'Estructur en tres pasos: 1.- Configurar la monitorización 2.- Entrega del test 3. Comprobación del lanzamiento'
    },
        {
      title: 'Resultados',
      description: 'Revisar el resultado global, mantener pruebas automáticas programadas y generar pruebas de rendimiento'
    }
  ]

}
